import {
  getOnBoardPassengers,
  getPassengerCount,
} from '@backoffice-frontend/ad-passenger-list'
import { Divider } from '@backoffice-frontend/patterns'
import { Callout } from '@moia-dev/pace-web'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TelematicsCheck } from '../../TelematicsCheck'
import { ActionCard } from '../ActionCard'
import { ServiceCancellationInteraction } from './ServiceCancellationInteraction'
import type { AdVehicleStreamServiceCancellationActionCardVehicleFragment } from './serviceCancellationActionCard.hook'

export const ServiceCancellationActionCard = ({
  vehicle,
}: {
  vehicle: AdVehicleStreamServiceCancellationActionCardVehicleFragment
}) => {
  const { t } = useTranslation()

  const [skipTelematicsCheck, setSkipTelematicsCheck] = useState(false)
  const vehicleIsStopped = vehicle.latestADTelemetry?.speed?.value === 0
  const onBoardPassengers = getOnBoardPassengers(
    vehicle.fccUpcomingWaypoints ?? [],
  )
  const onBoardPassengerCount = getPassengerCount(onBoardPassengers)
  const isStopRequired = onBoardPassengerCount > 0

  return (
    <ActionCard
      headline={
        isStopRequired
          ? t('adFleetMap_serviceCancellationActionCardHeader_caption')
          : t('adFleetMap_serviceActions_confirmCancellation_button')
      }
    >
      <div
        css={theme => ({
          padding: theme.space.Space4,
          display: 'flex',
          flexDirection: 'column',
          gap: theme.space.Space4,
          flexGrow: 1,
        })}
      >
        {isStopRequired ? (
          <>
            <Callout
              title={t('adFleetMap_requestVehicleStop_button')}
              hideDismiss
            >
              {t('adFleetMap_pleaseContactSafetyDriver_label')}
            </Callout>
            {!vehicleIsStopped ? (
              skipTelematicsCheck ? (
                <TelematicsCheck
                  title={t('adFleetMap_vehicleIsStanding_label')}
                  subtitle={t('adFleetMap_telematicsCheckSkipped_label')}
                  variant="overwrite"
                />
              ) : (
                <TelematicsCheck
                  title={t('adFleetMap_vehicleIsMoving_label')}
                  subtitle={t('adFleetMap_pendingTelematicsCheck_label')}
                  variant="pending"
                />
              )
            ) : (
              <TelematicsCheck
                title={t('adFleetMap_vehicleIsStanding_label')}
                subtitle={t('adFleetMap_telematicsCheckSuccessful_label')}
                variant="success"
              />
            )}
          </>
        ) : (
          <TelematicsCheck
            title={t('adFleetMap_noPassengerOnBoard_label')}
            subtitle={false}
            variant="success"
          />
        )}
      </div>

      <Divider />
      <ServiceCancellationInteraction
        vehicleId={vehicle.id}
        isStopRequired={isStopRequired}
        vehicleIsStopped={vehicleIsStopped}
        skipTelematicsCheck={skipTelematicsCheck}
        setSkipTelematicsCheck={setSkipTelematicsCheck}
      />
    </ActionCard>
  )
}
